export default __webpack_public_path__ + "static/3-757e32b5939f5a3c0f7cd36c37b70861.jpeg";